module.exports = __webpack_public_path__ + "img/telphone.05078ba8.svg";